"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasOnlySupportedVariables = exports.bodySupportedVariables = exports.schedulingLinkValid = exports.isEqual = exports.interpolate = exports.defaultPhonescreenSequence = exports.defaultOutreachSequence = exports.getSequenceVariables = exports.isRevivalSequence = exports.validateSequence = exports.SequenceType = exports.disclaimerTextHtml = void 0;
const lodash_1 = require("lodash");
const validator = require("validator");
const interpolate_template_1 = require("../common/interpolate-template");
const scheduling_link_utils_1 = require("../common/scheduling-link-utils");
var SequenceType;
(function (SequenceType) {
    SequenceType["Outreach"] = "initial_outreach";
    SequenceType["Phonescreen"] = "phonescreen";
})(SequenceType || (SequenceType = {}));
exports.SequenceType = SequenceType;
function getSequenceVariables(data) {
    var _a, _b;
    const { person, job, senderAccount, customText, subject, client, phoneCallSchedulingLink, disclaimerText, user } = data;
    const { link, text } = (0, scheduling_link_utils_1.getSchedulingLink)(phoneCallSchedulingLink, person.id, job.id, client.name);
    let senderSignature = senderAccount.name.first;
    if (user && user.name.full === ((_a = senderAccount === null || senderAccount === void 0 ? void 0 : senderAccount.name) === null || _a === void 0 ? void 0 : _a.full)) {
        senderSignature = (_b = user.signature) !== null && _b !== void 0 ? _b : senderSignature;
    }
    return {
        customText,
        disclaimerText,
        firstName: person.name.first,
        fullName: person.name.full,
        phoneCallSchedulingLink: link,
        phoneCallSchedulingLinkText: text,
        senderFirstName: senderAccount.name.first,
        senderFullName: senderAccount.name.full,
        senderSignature,
        subject
    };
}
exports.getSequenceVariables = getSequenceVariables;
function modifyTemplateVariables(content, modifier) {
    let newContent = content;
    const matched = content.match(/\{\{(.+?)\}\}/g);
    if (matched) {
        for (const match of matched) {
            const re = new RegExp((0, lodash_1.escapeRegExp)(match), 'g');
            const replaceValue = modifier(match);
            newContent = newContent.replace(re, replaceValue);
        }
    }
    return newContent;
}
function standardizeVariable(variable) {
    const v = variable.replace(/ /g, '').toLocaleLowerCase();
    // cspell:disable
    if (v === '{{firstname}}') {
        return '{{firstName}}';
    }
    else if (v === '{{fullname}}') {
        return '{{fullName}}';
    }
    else if (v === '{{senderfirstname}}') {
        return '{{senderFirstName}}';
    }
    else if (v === '{{sendersignature}}') {
        return '{{senderSignature}}';
    }
    else if (v === '{{senderfullname}}') {
        return '{{senderFullName}}';
    }
    else if (v === '{{phonecallschedulinglinktext}}') {
        return '{{phoneCallSchedulingLinkText}}';
    }
    else if (v === '{{phonecallschedulinglink}}') {
        return '{{phoneCallSchedulingLink}}';
    }
    else if (v === '{{subject}}') {
        return '{{subject}}';
    }
    else if (v === '{{customtext}}') {
        return '{{customText}}';
    }
    else if (v === '{{disclaimertext}}') {
        return '{{disclaimerText}}';
    }
    else {
        return variable;
    }
    // cspell:enable
}
function interpolate(content, variables) {
    const standardizedTemplate = modifyTemplateVariables(content, standardizeVariable);
    return (0, interpolate_template_1.interpolateTemplate)(standardizedTemplate, variables);
}
exports.interpolate = interpolate;
const requiredVariables = {
    [SequenceType.Outreach]: ['first name', 'sender signature', 'disclaimer text'],
    [SequenceType.Phonescreen]: ['first name', 'sender signature']
};
const subjectSupportedVariables = [
    'first name',
    'full name',
    'sender first name',
    'sender full name',
    'subject',
    'custom text',
    'phone call scheduling link',
    'phone call scheduling link text',
    'subject'
];
const bodySupportedVariables = [
    'first name',
    'full name',
    'sender first name',
    'sender full name',
    'sender signature',
    'custom text',
    'phone call scheduling link',
    'phone call scheduling link text',
    'disclaimer text'
];
exports.bodySupportedVariables = bodySupportedVariables;
function hasRequiredVariables(allVariables, type) {
    const sequenceRequiredVariables = requiredVariables[type];
    for (const requiredVariable of sequenceRequiredVariables) {
        if (allVariables.indexOf(requiredVariable) === -1) {
            return false;
        }
    }
    return true;
}
// tslint:disable:no-console
function checkVariablesHaveBraces(text, supportedVariables) {
    for (const variable of supportedVariables) {
        const variableInBracketsRegex = new RegExp(`..${variable}..`, 'gi');
        const variableMatches = text.match(variableInBracketsRegex);
        const variableWithoutBraces = (0, lodash_1.some)(variableMatches, (match) => {
            return !match.startsWith('{{') || !match.endsWith('}}');
        });
        if (variableWithoutBraces) {
            console.log(`The variable ${variable} appears without curly braces!`);
            return false;
        }
    }
    return true;
}
function checkBracesAreValid(text) {
    let strPos = 0;
    let areBracesOpen = false; // Keeps track of opened braces that must be closed
    while (strPos < text.length) {
        const letter = text[strPos];
        switch (letter) {
            case '{':
                if (areBracesOpen) {
                    // There are still braces that need to be closed
                    return false;
                }
                strPos += 1; // Next character must be a brace
                if (strPos === text.length) {
                    return false;
                }
                if (text[strPos] === '{') {
                    areBracesOpen = true;
                }
                else {
                    return false;
                }
                break;
            case '}':
                if (!areBracesOpen) {
                    return false;
                }
                strPos += 1;
                if (strPos === text.length) {
                    return false;
                }
                if (text[strPos] === '}') {
                    areBracesOpen = false;
                }
                else {
                    return false;
                }
                break;
            default:
                break;
        }
        strPos += 1;
    }
    return !areBracesOpen;
}
function hasOnlySupportedVariables(allVariables, supportedVariables) {
    for (const variable of allVariables) {
        if (supportedVariables.indexOf(variable) === -1) {
            return false;
        }
    }
    return true;
}
exports.hasOnlySupportedVariables = hasOnlySupportedVariables;
function checkSchedulingLinkFormat(body) {
    var _a;
    const groups = (_a = body.match(/<a.*href="(.*?)".*>.*{{Phone Call Scheduling Link Text}}.*<\/a>/gi)) !== null && _a !== void 0 ? _a : [];
    for (const group of groups) {
        const match = group.match(/<a.*href="(.*?)".*>.*{{Phone Call Scheduling Link Text}}.*<\/a>/i);
        if (match[1].toLowerCase() !== '{{phone call scheduling link}}') {
            return false;
        }
    }
    const invalidLink = body.match(/<a href=(.*titan\.getrocket\.com.*?)<\/a>/gi);
    if (!!invalidLink) {
        return false;
    }
    return true;
}
function basicSequenceChecks(emailSequence) {
    if (!emailSequence) {
        console.log(`GENERAL CHECK:not a sequence`);
        return false;
    }
    const sequenceTitle = emailSequence.title;
    for (let i = 0; i < emailSequence.stages.length; i++) {
        const stage = emailSequence.stages[i];
        if (i === 0 && stage.subject.trim().length === 0) {
            console.log(`GENERAL CHECK:A stage in sequence ${sequenceTitle} has no subject`);
            return false;
        }
        if (stage.body.trim().length === 0) {
            console.log(`GENERAL CHECK:A stage in sequence ${sequenceTitle} has no body`);
            return false;
        }
        if (!checkBracesAreValid(stage.body) || !checkBracesAreValid(stage.subject)) {
            console.log(`GENERAL CHECK:A stage in sequence ${sequenceTitle} has invalid brackets`);
            return false;
        }
        const textWithoutVariablesInBraces = stage.body.replace(/\{\{(.*?)\}\}/g, '');
        if (!checkVariablesHaveBraces(textWithoutVariablesInBraces, bodySupportedVariables)) {
            console.log(`GENERAL CHECK:A stage in sequence ${sequenceTitle} has a variable without brackets`);
            return false;
        }
        const variablesInBody = stage.body.match(/\{\{(.*?)\}\}/g);
        const allVariablesMatch = variablesInBody
            ? variablesInBody.map((a) => a.replace(/\s*\|\s*fallback:.*?\}\}/, '}}'))
            : [];
        if (!allVariablesMatch) {
            console.log(`GENERAL CHECK:Not all stages in the sequence ${sequenceTitle} have variables`);
            return false;
        }
        const allVariables = allVariablesMatch.map((variable) => variable.slice(2, -2).toLowerCase()); // tslint:disable-line:no-magic-numbers max-line-length
        if (!hasRequiredVariables(allVariables, emailSequence.type)) {
            console.log(`GENERAL CHECK:A stage in sequence ${sequenceTitle} does not have all required variables`);
            return false;
        }
        if (!hasOnlySupportedVariables(allVariables, bodySupportedVariables)) {
            console.log(`GENERAL CHECK:A stage in sequence ${sequenceTitle} has unsupported variables`);
            return false;
        }
        if (!checkSchedulingLinkFormat(stage.body)) {
            console.log(`GENERAL CHECK:A stage in sequence ${sequenceTitle} has incorrectly formatted scheduling link`);
            return false;
        }
    }
    return true;
}
function outreachSequenceValid(emailSequence) {
    if (!basicSequenceChecks(emailSequence)) {
        return false;
    }
    const sequenceTitle = emailSequence.title;
    for (const stage of emailSequence.stages) {
        const variablesMatchInSubject = stage.subject.match(/\{\{(.*?)\}\}/g);
        if (variablesMatchInSubject) {
            const variablesInSubject = variablesMatchInSubject.map((variable) => variable.slice(2, -2).toLowerCase()); // tslint:disable-line:no-magic-numbers max-line-length
            if (!hasOnlySupportedVariables(variablesInSubject, subjectSupportedVariables)) {
                console.log(`OUTREACH: The sequence ${sequenceTitle} has illegal variables in the subject`);
                return false;
            }
        }
    }
    return true;
}
function schedulingSequenceValid(emailSequence) {
    if (!basicSequenceChecks(emailSequence)) {
        return false;
    }
    const sequenceTitle = emailSequence.title;
    for (const stage of emailSequence.stages) {
        const bodyText = stage.body.replace(/<[^>]*>/g, '');
        if (!bodyText.match(/\{\{phone call scheduling link.*?\}\}/i)) {
            console.log(`SCHEDULE: A stage in the sequence ${sequenceTitle} does not have a calendar!`);
            return false;
        }
    }
    if (emailSequence.stages[0].subject.toLowerCase() === '{{subject}}') {
        return true;
    }
    console.log(`SCHEDULE: The first stage in ${sequenceTitle} does not have its subject set correctly to {{subject}}`);
    return false;
}
// tslint:enable
function schedulingLinkValid(text) {
    return text.match(/^https:\/\/calendly\.com\//) && validator.isURL(text) && !text.endsWith('/');
}
exports.schedulingLinkValid = schedulingLinkValid;
function validateSequence(sequence) {
    const { type } = sequence;
    if (type === SequenceType.Outreach) {
        return outreachSequenceValid(sequence);
    }
    else if (type === SequenceType.Phonescreen) {
        return schedulingSequenceValid(sequence);
    }
    return false; // Invalid Type
}
exports.validateSequence = validateSequence;
const defaultOutreachSequence = {
    archived: false,
    bcc: [],
    cc: [],
    contentHash: undefined,
    createdAt: undefined,
    hidden: false,
    id: undefined,
    jobId: undefined,
    modifiedAt: undefined,
    stages: [
        {
            attachments: [],
            body: `<div>Hi {{First Name}},</div><br><div><br></div><div>{{CUSTOM OUTREACH TEXT}}</div><div><br></div><br><div>Best,</div><div>{{Sender Signature}}</div><div style="font-size:0.8rem;color:#888;font-style:italic"><br/>{{Disclaimer Text}}</div>`,
            subject: '{{Enter Subject}}',
            waitDays: 0
        },
        {
            attachments: [],
            body: `<div>Hey {{First Name}}!</div><br><div>Just following up on my previous email about {{ROLE}}. Let me know if you’re free sometime this week or next.</div><br><div>I’d love to hop on a quick phone call to learn more about you.</div><br><div>Best,</div><div>{{Sender Signature}}</div><div style="font-size:0.8rem;color:#888;font-style:italic"><br/>{{Disclaimer Text}}</div>`,
            subject: '',
            waitDays: 5
        }
    ],
    title: 'Initial Outreach',
    type: SequenceType.Outreach,
    weekDaysOnly: undefined
};
exports.defaultOutreachSequence = defaultOutreachSequence;
const defaultPhonescreenSequence = {
    archived: false,
    bcc: [],
    cc: [],
    contentHash: undefined,
    createdAt: undefined,
    hidden: false,
    id: undefined,
    jobId: undefined,
    modifiedAt: undefined,
    stages: [
        {
            attachments: [],
            body: `<div>Hey {{First Name}},</div><div><br></div><div>Great to hear from you. I’d be happy to hop on a call to provide some more information on {{ROLE}}</div><div>Let me know what is a good time for us to get on a call, or if more convenient, I am including a link to my calendar: <a href="{{Phone Call Scheduling Link}}">{{Phone Call Scheduling Link Text}}</a></div><div><br></div><div>Please let me know if you can’t find any time slots that work for you, and I can move things around. Look forward to speaking with you soon!</div><div><br></div><div>Best,</div><div>{{Sender Signature}}</div>`,
            subject: '{{Subject}}',
            waitDays: 0
        },
        {
            attachments: [],
            body: `<div>Hi {{First Name}}</div><div><br></div><div>Hope you are well. I’m following up to see if you’re still interested in learning more about {{ROLE}}. I’m excited to share specifics with you!</div><div><br></div><div>Please select a time on my calendar here: <span style="background-color: white;"><a href="{{Phone Call Scheduling Link}}">{{Phone Call Scheduling Link Text}}</a></span></div><div><br></div><div>If you need a specific time that isn’t available, let me know what works for you.</div><div><br></div><div>Best,</div><div>{{Sender Signature}}</div>`,
            subject: '',
            waitDays: 2
        },
        {
            attachments: [],
            body: `<div>Hey {{First Name}},</div><div><br></div><div>Bubbling this to the top of your inbox in case you missed my previous emails. Please let me know if you’re still interested in {{ROLE}}!</div><div><br></div><div>Feel free to schedule a time to chat here: <a href="{{Phone Call Scheduling Link}}">{{Phone Call Scheduling Link Text}}</a></div><div><br></div><div>Thanks,</div><div>{{Sender Signature}}</div>`,
            subject: '',
            waitDays: 3
        }
    ],
    title: 'Phone call Scheduling',
    type: SequenceType.Phonescreen,
    weekDaysOnly: false
};
exports.defaultPhonescreenSequence = defaultPhonescreenSequence;
function isRevivalSequence(sequence) {
    return sequence.type === SequenceType.Outreach && !!sequence.title.match(/^Revival/i);
}
exports.isRevivalSequence = isRevivalSequence;
function isEqual(seq1, seq2) {
    return (0, lodash_1.isEqual)((0, lodash_1.pick)(seq1, ['stages', 'cc', 'bcc', 'weekDaysOnly']), (0, lodash_1.pick)(seq2, ['stages', 'cc', 'bcc', 'weekDaysOnly']));
}
exports.isEqual = isEqual;
exports.disclaimerTextHtml = `<div style="font-size: 0.8rem; color: rgb(136, 136, 136); font-style: italic;"><br>{{Disclaimer Text}}</div>`;
//# sourceMappingURL=sequence.js.map